module.exports = __webpack_public_path__ + "img/house-1.5120ad22.jpeg";